<app-breadcrumbs></app-breadcrumbs>
<h1>2024</h1>
<div [cfaLoading]="isLoading">


    <div class="section-header">
        <h3 class="subheading"></h3>
        <div class="nav-cards-container" class="cards">
            <!-- <mat-card class="card">
                    <mat-card-content class="card-content">
                        <h3 class="card-header">{{ 'X' }}</h3>
                        metric
                    </mat-card-content>
            </mat-card> -->
            <!-- <mat-card class="card">
                    <mat-card-content class="card-content">
                        <h3 class="card-header">{{ this.all61Fs.length }}</h3>
                        61Fs deployed
                    </mat-card-content>
            </mat-card> -->

            <!-- <mat-card class="card">
                    <mat-card-content class="card-content">
                        <h3 class="card-header">{{ this.allMS210s.length }}</h3>
                        MS210s deployed
                    </mat-card-content>
            </mat-card> -->
            <mat-card class="card">
                <mat-card-content class="card-content">
                    <h3 class="card-header">{{ this.sitesRefreshed2024.length + this.countSitesRefreshedRemodels2024 }}</h3>
                    total sites refreshed 
                </mat-card-content>
            </mat-card>
            <mat-card class="card">
                <mat-card-content class="card-content">
                    <h3 class="card-header">{{ this.sitesRefreshed2024.length }}</h3>
                    normal refreshes
                </mat-card-content>
            </mat-card>
            <mat-card class="card">
                <mat-card-content class="card-content">
                    <h3 class="card-header">{{ this.countSitesRefreshedRemodels2024 }}</h3>
                    remodel refreshes 
                </mat-card-content>
            </mat-card>
            <mat-card class="card">
                <mat-card-content class="card-content">
                    <h3 class="card-header">{{ this.PLANNED_REFRESHES_2024 }}</h3>
                    sites planned
                </mat-card-content>
            </mat-card>
            <mat-card class="card">
                <mat-card-content class="card-content">
                    <h3 class="card-header">{{ (this.sitesRefreshed2024.length + this.countSitesRefreshedRemodels2024) / this.PLANNED_REFRESHES_2024 * 100 | number : '1.0-0' }}%</h3>
                    complete
                </mat-card-content>
            </mat-card>

        </div>
    </div>

    <!-- <div class="section-header">
        <h3 class="subheading">Fortinets</h3>
        <div class="nav-cards-container" class="cards">
            <mat-card class="card">
                    <mat-card-content class="card-content">
                        <h3 class="card-header">{{ fortinetAvgOfflineEventsPerDay | number : '1.2-2' }}</h3>
                        avg offline events/day
                    </mat-card-content>
            </mat-card>
            <mat-card class="card">
                    <mat-card-content class="card-content">
                        <h3 class="card-header">{{ fortinetAvailCurrentMonth | number : '1.2-2' }} %</h3>
                        this month
                    </mat-card-content>
            </mat-card>
        </div>
    </div> -->

    <div echarts [options]="ytdRefreshesOption" class="demo-chart"></div>
    <mat-progress-bar class="progress-bar" mode="determinate" value="{{ (this.sitesRefreshed2024.length + this.countSitesRefreshedRemodels2024) / this.PLANNED_REFRESHES_2024 * 100 | number : '1.0-0' }}"></mat-progress-bar>
    
    <h1>Total</h1>
    <div class="section-header">
        <!-- <h3 class="subheading"></h3> -->
        <div class="nav-cards-container" class="cards">
            <mat-card class="card">
                    <mat-card-content class="card-content">
                        <h3 class="card-header">{{ this.sitesRefreshed.length + this.countSitesRefreshedRemodels2023 + this.countSitesRefreshedRemodels2024 }}</h3>
                        total sites refreshed
                    </mat-card-content>
            </mat-card>
            <mat-card class="card">
                    <mat-card-content class="card-content">
                        <h3 class="card-header">{{ this.sitesRefreshed.length }}</h3>
                        normal refreshes
                    </mat-card-content>
            </mat-card>
            <mat-card class="card">
                    <mat-card-content class="card-content">
                        <h3 class="card-header">{{ this.countSitesRefreshedRemodels2023 + this.countSitesRefreshedRemodels2024 }}</h3>
                        remodel refreshes
                    </mat-card-content>
            </mat-card>

            <!-- <mat-card class="card">
                <mat-card-content class="card-content">
                    <h3 class="card-header">{{ this.allMS210sKevlar2.length }}</h3>
                    MS210s for Kevlar2
                </mat-card-content>
            </mat-card> -->
            <!-- <mat-card class="card">
                <mat-card-content class="card-content">
                    <h3 class="card-header">{{ this.all61FsKevlar2.length }}</h3>
                    61Fs for Kevlar2
                </mat-card-content>
            </mat-card> -->
            <mat-card class="card">
                <mat-card-content class="card-content">
                    <h3 class="card-header">{{ this.countAp63Remediations }}</h3>
                    AP63E remediations
                </mat-card-content>
            </mat-card> 
        </div>
    </div>
</div>
